/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: ea99bacb (Fri Jun  5 23:34:18 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface FetchEventOptionsResponseOptionsEventTypes
 */
export interface FetchEventOptionsResponseOptionsEventTypes {
  /**
   * Name of the event type.
   * @type string
   * @memberof FetchEventOptionsResponseOptionsEventTypes
   */
  name: string
  /**
   *
   * @type string
   * @memberof FetchEventOptionsResponseOptionsEventTypes
   */
  category?: string
}

export function FetchEventOptionsResponseOptionsEventTypesFromJSON(
  json: any
): FetchEventOptionsResponseOptionsEventTypes {
  return FetchEventOptionsResponseOptionsEventTypesFromJSONTyped(json, false)
}

export function FetchEventOptionsResponseOptionsEventTypesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchEventOptionsResponseOptionsEventTypes {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: json['name'],
    category: !exists(json, 'category') ? undefined : json['category'],
  }
}

export function FetchEventOptionsResponseOptionsEventTypesToJSON(
  value?: FetchEventOptionsResponseOptionsEventTypes | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    category: value.category,
  }
}
